/**
 * Detecta "equipos" que son casillas de bracket sin definir
 * (cruces de eliminatoria: "Group F Winner", "2nd Place", "Third Place Group...").
 * Debe coincidir con backend/utils/placeholderTeams.js
 */
const PLACEHOLDER_RE = new RegExp(
  [
    'group\\s+[a-l]\\b', '\\bwinner\\b', '\\bloser\\b', '\\brunner[- ]?up\\b',
    'round of \\d', 'quarterfinal', 'semifinal', 'octavos', 'cuartos', 'semifinales',
    '\\d+(st|nd|rd|th)\\s+place', 'first place', 'second place',
    'third place', 'fourth place', '\\bplace\\b',
    'ganador', 'perdedor', 'segundo', 'tercer', 'clasificado',
    '\\btbd\\b', 'to be determined', 'por definir',
  ].join('|'),
  'i'
);

export const isPlaceholderName = (nombre?: string): boolean =>
  !!nombre && PLACEHOLDER_RE.test(nombre);

export const isPlaceholderMatch = (local?: string, visitante?: string): boolean =>
  isPlaceholderName(local) || isPlaceholderName(visitante);
